import { Link } from 'react-router-dom'
import { useLocale } from '../i18n/context'

export default function NotFoundPage() {
  const { tr } = useLocale()
  const nf = tr.notFound
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--bg-page)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: 24,
    }}>
      <div style={{ fontSize: 72, fontWeight: 700, color: 'var(--border)', lineHeight: 1, marginBottom: 16 }}>
        404
      </div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 }}>
        {nf.title}
      </h1>
      <p style={{ color: 'var(--text-secondary)', fontSize: 15, marginBottom: 32, maxWidth: 360 }}>
        {nf.message}
      </p>
      <Link
        to="/home"
        style={{
          backgroundColor: 'var(--accent-fill)',
          color: 'var(--text-on-accent)',
          borderRadius: 'var(--radius-pill)',
          padding: '12px 28px',
          fontSize: 15, fontWeight: 600,
          textDecoration: 'none',
        }}
      >
        {nf.goHome}
      </Link>
    </div>
  )
}
